import Tabs from "components/lib/Shared/Tabs";
import InvoicesTable from "components/OrgAndSuperAdminDashboard/Billing/Invoices";
import SubscriptionPlans from "components/OrgAndSuperAdminDashboard/Subscriptions/SubscriptionPlans";
import React, { useEffect, useState } from "react";

const tabs = [
  {
    id: "subscriptionPlans",
    label: "Subscription Plans",
  },
  {
    id: "invoices",
    label: "Invoices",
  },
];
const Billing = () => {
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  return (
    <div>
      <Tabs
        tabs={tabs}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
      />
      <div>
        {selectedTab.id === "subscriptionPlans" && (
          <SubscriptionPlans manageSubscriptions={false} />
        )}
        {selectedTab.id === "invoices" && <InvoicesTable />}
      </div>
    </div>
  );
};

export default Billing;
